
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const ProjectsPage = () => {
  const projects = [
    {
      title: '大發工業區廠房內設備噴砂噴漆',
      category: '工業設施',
      description: '大型廠房建構噴砂除鏽與防鏽噴漆工程',
      image: 'https://public.readdy.ai/ai/img_res/e0474b932ba24c7c4cea8708d7fdd671.jpg',
      year: '2023',
      details: '本專案為施工期長達一年的大型工業區廠房內建構鋼構的分段區域噴砂噴漆工程，包含屋頂及支撐架、防鏽底漆處理及高品質面漆施工。施工期間嚴格遵守安全規範，確保工程品質與進度。'
    },
    {
      title: '楠梓中油廠區翻土設備除鏽上漆',
      category: '公共設施',
      description: '楠梓中油廠區翻土設備除鏽上漆',
      image: 'https://readdy.ai/api/search-image?query=Port%20crane%20and%20steel%20structure%20maintenance%20project%20in%20Taiwan%2C%20professional%20sandblasting%20and%20painting%20on%20harbor%20equipment%20by%20Taiwanese%20workers%2C%20industrial%20port%20facility%20with%20protective%20coating%20work%2C%20maritime%20infrastructure%20maintenance%20by%20Asian%20engineering%20team%2C%20professional%20surface%20treatment%20on%20heavy%20machinery&width=500&height=350&seq=project-2-taiwan&orientation=landscape',
      year: '2023',
      details: '翻土設備除鏽上漆專案，針對中油協力廠商指定規範要求，將翻土設備進行指定專業噴砂除鏽與防腐塗裝。考量廢油侵蝕及運作的高溫因素，採用特殊防鏽塗料，確保設備長期使用安全。'
    },
    {
      title: '重機械設備運輸專案',
      category: '運輸工程',
      description: '大型工業設備與重機械的專業運輸服務，包含路線規劃與安全護送',
      image: 'https://readdy.ai/api/search-image?query=Professional%20white%20HINO%20truck%20tractor%20unit%20pulling%20heavy%20machinery%20transport%20trailer%20in%20Taiwan%2C%20single%20truck%20head%20without%20multiple%20tractors%2C%20carrying%20large%20industrial%20equipment%20and%20heavy%20machinery%20tools%2C%20operated%20by%20Taiwanese%20drivers%2C%20heavy%20haul%20logistics%20service%20with%20clean%20white%20HINO%20brand%20truck%20cab%2C%20industrial%20equipment%20transportation%20with%20safety%20escort%20vehicles%2C%20professional%20heavy%20transport%20operation%20by%20Asian%20team&width=500&height=350&seq=project-3-hino-corrected&orientation=landscape',
      year: '2023',
      details: '提供專業重機械運輸服務，包含大型挖掘機、工業設備等的安全運送。配備專業運輸車輛與經驗豐富的駕駛團隊，確保設備運輸過程安全無虞。'
    },
    {
      title: '知名化工廠設備更新',
      category: '化工設施',
      description: '化工廠內反應器與儲槽的專業噴砂噴漆工程',
      image: 'https://readdy.ai/api/search-image?query=Chemical%20plant%20equipment%20renovation%20in%20Taiwan%20with%20professional%20sandblasting%20and%20painting%20by%20Taiwanese%20workers%2C%20industrial%20reactors%20and%20storage%20tanks%20with%20protective%20coating%2C%20clean%20chemical%20facility%20with%20safety%20standards%2C%20professional%20surface%20treatment%20on%20industrial%20equipment%20by%20Asian%20engineering%20team&width=500&height=350&seq=project-4-taiwan&orientation=landscape',
      year: '2022',
      details: '化工廠設備更新專案，針對反應器、儲槽等關鍵設備進行表面處理。嚴格遵守化工安全規範，使用符合化工環境的特殊塗料，確保設備安全運作。'
    },
    {
      title: '知名鋼鐵廠維護專案',
      category: '鋼鐵工業',
      description: '鋼鐵廠生產設備的定期維護與表面處理工程',
      image: 'https://readdy.ai/api/search-image?query=Steel%20mill%20production%20equipment%20maintenance%20project%20in%20Taiwan%2C%20professional%20surface%20treatment%20on%20heavy%20industrial%20machinery%20by%20Taiwanese%20workers%2C%20steel%20manufacturing%20facility%20with%20protective%20coating%20work%2C%20industrial%20maintenance%20with%20safety%20protocols%20by%20Asian%20engineering%20professionals&width=500&height=350&seq=project-5-taiwan&orientation=landscape',
      year: '2021',
      details: '鋼鐵廠生產線設備維護工程，包含高溫設備的特殊防護塗裝。針對高溫、高腐蝕環境，採用耐高溫防腐塗料，延長設備使用壽命。'
    },
    {
      title: '公共建設橋樑維護',
      category: '公共工程',
      description: '大型橋樑鋼構的防腐蝕處理與美化工程',
      image: 'https://readdy.ai/api/search-image?query=Bridge%20steel%20structure%20maintenance%20and%20anti-corrosion%20treatment%20in%20Taiwan%2C%20professional%20workers%20applying%20protective%20coating%20on%20large%20bridge%20infrastructure%2C%20Taiwanese%20engineering%20team%20working%20on%20public%20construction%20project%2C%20modern%20bridge%20maintenance%20with%20safety%20equipment%20and%20professional%20surface%20treatment&width=500&height=350&seq=project-6-taiwan&orientation=landscape',
      year: '2021',
      details: '公共橋樑維護專案，針對橋樑鋼構進行全面防腐蝕處理。考量交通安全與工程品質，採用分段施工方式，確保交通順暢與工程品質。'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                工程實績展示
              </h1>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                多年來我們完成了眾多<strong>噴砂噴漆</strong>與<strong>工程承攬</strong>專案，
                從工業設施到公共建設，每一個項目都展現我們的專業技術與品質堅持。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {projects.map((project, index) => (
                <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                  <div className="relative h-48 overflow-hidden">
                    <img 
                      src={project.image}
                      alt={project.title}
                      className="w-full h-full object-cover object-top"
                    />
                    <div className="absolute top-4 left-4 bg-teal-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                      {project.year}
                    </div>
                    <div className="absolute top-4 right-4 bg-white/90 text-gray-800 px-3 py-1 rounded-full text-sm font-medium">
                      {project.category}
                    </div>
                  </div>
                  <div className="p-6">
                    <h2 className="text-xl font-semibold text-gray-900 mb-3">{project.title}</h2>
                    <p className="text-gray-600 mb-4 leading-relaxed">{project.description}</p>
                    <p className="text-sm text-gray-500 leading-relaxed">{project.details}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-16 bg-white rounded-xl shadow-lg p-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">專案統計</h2>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                <div className="text-center p-4 bg-gray-50 rounded-lg">
                  <div className="text-3xl font-bold text-teal-600 mb-2">100+</div>
                  <div className="text-gray-600">完成專案</div>
                </div>
                <div className="text-center p-4 bg-gray-50 rounded-lg">
                  <div className="text-3xl font-bold text-teal-600 mb-2">50,000+</div>
                  <div className="text-gray-600">施工面積(㎡)</div>
                </div>
                <div className="text-center p-4 bg-gray-50 rounded-lg">
                  <div className="text-3xl font-bold text-teal-600 mb-2">98%</div>
                  <div className="text-gray-600">客戶滿意度</div>
                </div>
                <div className="text-center p-4 bg-gray-50 rounded-lg">
                  <div className="text-3xl font-bold text-teal-600 mb-2">0</div>
                  <div className="text-gray-600">安全事故</div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ProjectsPage;
